export default {
    handle(bloodDonorModel) {
        bloodDonorModel.region = !!bloodDonorModel.otherRegion
            ? bloodDonorModel.otherRegion
            : bloodDonorModel.region;

        return true;
    }
}